import {
  GET_AVAILABLE_WIDGETS_FETCH_ERROR,
  GET_AVAILABLE_WIDGETS_FETCH_START,
  GET_AVAILABLE_WIDGETS_FETCH_SUCCESS,
} from "../reducers/AvailableWidgetsReducer";
import { getAllAvailableWidgets } from "../../network/WCSSNetwork";

// Currently statically defined until getAllWidgets API is created
export const WIDGET_IDS_TO_FETCH = [
  "MISAPPLIED_SAL",
  "MISSED_INDUCT",
  "INC",
  "MISSED_INDUCT_PACKAGES_TOTAL",
  "inductionTrendWidget",
  "MISDIVERT_PACKAGES_PENDING_PS",
];

/**
 * Get all available widgets for displaying in the widget picket
 */
export function getAvailableWidgets() {
  return async (dispatch) => {
    dispatch({ type: GET_AVAILABLE_WIDGETS_FETCH_START });

    try {
      const getWidgetsResponse = await getAllAvailableWidgets();
      const widgetConfigs = getWidgetsResponse.data.widgets.map((widget) => {
        return {
          widgetId: widget.widgetId,
          widgetDefinition: JSON.parse(widget.config),
        };
      });

      dispatch({
        type: GET_AVAILABLE_WIDGETS_FETCH_SUCCESS,
        payload: widgetConfigs,
      });
    } catch (err) {
      dispatch({
        type: GET_AVAILABLE_WIDGETS_FETCH_ERROR,
        error: err.message,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/thunks/AvailableWidgetsDispatcher.js